export const PPTX_MIME = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
export const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
/** Power BI Desktop; some servers use octet-stream — also match by `.pbix` in file name */
export const PBIX_MIME = 'application/vnd.ms-powerbi'
export const CSV_MIME = 'text/csv'
export const IPYNB_MIME = 'application/x-ipynb+json'

/**
 * File types we do not preview inline but allow downloading.
 */
export function shouldOfferResourceDownload(contentType: string | undefined, fileName: string | undefined): boolean {
  const lower = fileName?.toLowerCase() ?? ''

  const inlinePreviewable = [
    '.pdf',
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.webp',
    '.svg',
    '.bmp',
    '.mp4',
    '.mov',
    '.avi',
    '.webm',
    '.mkv',
    '.txt',
    '.md',
    '.yaml',
    '.yml',
    '.py',
    '.pptx',
    '.doc',
    '.docx',
  ]

  // ZIP has its own dedicated viewer path
  if (lower.endsWith('.zip')) return false

  if (lower && !inlinePreviewable.some(ext => lower.endsWith(ext))) {
    return true
  }

  if (!contentType) return false
  // DOCX is now inline-previewable via Office Online viewer
  if (contentType.includes(XLSX_MIME)) return true
  if (contentType.includes(PBIX_MIME)) return true
  if (contentType.includes(CSV_MIME)) return true
  if (contentType.includes(IPYNB_MIME)) return true
  return false
}

export const PROSE_SIZE_MAP = {
  sm: 'prose-sm',
  base: 'prose-base',
  lg: 'prose-lg',
} as const
